<template>
    <v-dialog
        :value="dispositionOpen"
        width= 50%
        persistent
        outline
        :disabled="!canDispose"
    >
        <template v-slot:activator="{ on }">
          <span v-on="on">
              <slot />
          </span>
        </template>

        <v-card>
            <v-card-title class="text-h5" primary-title>
                Resolve Disposition
            </v-card-title>
            <v-divider />
            <v-card-text>
                <v-form ref="dispositionForm">
                    <v-layout>
                        <v-flex xs6 class="px-2">
                            <v-select
                              data-testid="select-call-type-menu"
                              class="select-call-type-menu"
                              v-model="callType"
                              filled
                              :items="callTypes"
                              item-text="name"
                              return-object
                              label="Select a call type."
                              required
                              :rules="inputRules"
                            />
                        </v-flex>
                        <v-flex xs6 class="px-2">
                            <v-select
                              data-testid="select-disposition-menu"
                              class="select-disposition-menu"
                              v-model="disposition"
                              filled
                              :items="dispositions"
                              :disabled="!dispositions.length"
                              item-text="name"
                              return-object
                              label="Select a disposition."
                              required
                              :rules="inputRules"
                            />
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                  data-testid="cancel-disposition-btn"
                  class="cancel-disposition-btn"
                  color="error"
                  @click="resetTimer"
                >
                  Cancel
                </v-btn>
                <v-spacer />
                <v-btn
                  data-testid="submit-disposition-btn"
                  class="submit-disposition-btn"
                  :disabled="!validDisposition"
                  :loading="loading"
                  color="primary"
                  @click="submitDisposition"
                >
                  Submit
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import "regenerator-runtime";
import { inputRules } from "@/helpers/form-rules";
import router from "@/router";

export default {
  name: "Disposition",

  props: {
    dispositionOpen: {
      type: Boolean
    },
    callActive: {
      type: Boolean
    },
    location: {
      type: [String, null]
    },
    isAccountsReceivable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      inputRules: inputRules,
      callTypes: [],
      callType: null,
      disposition: null,
      callTime: ""
    };
  },

  methods: {
    getCallTypes() {
      this.$store.dispatch("getCallTypes")
        .then(resp => {
          const filteredCallTypes = resp.data.call_types.filter(callType => callType.dispositions.length);
          this.callTypes = filteredCallTypes;
          this.loading = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    },

    async submitDisposition() {
      this.loading = true;
      this.callTime = localStorage.getItem("callEndTime") - localStorage.getItem("callStartTime");
      let payload = {
        ...this.$store.state.call,
        call_id: localStorage.getItem("callId"),
        converted_location_code: localStorage.getItem("locationCode"),
        disposition_id: this.disposition.id
      };

      this.$store.dispatch("endCall", payload)
        .then(() => {
          this.$store.dispatch("handleSuccess", "Disposition complete");
          this.$store.commit("commitAlerts", []);
          this.$store.commit("callEnded");
          this.$store.commit("endTwilioChat");
          this.loading = false;
          this.$emit("collapse");
          this.$refs.dispositionForm.reset();
          localStorage.removeItem("arActive");
          localStorage.removeItem("callStarted");
          localStorage.removeItem("nowTime");
          localStorage.removeItem("callStartTime");
          localStorage.removeItem("callEndTime");
          localStorage.removeItem("callTime");
          localStorage.removeItem("facilityId");
          localStorage.removeItem("tenantId");
          localStorage.removeItem("callId");
          localStorage.removeItem("ctmId");
          localStorage.removeItem("reservationId");
          localStorage.removeItem("refreshedFacilities");
          localStorage.removeItem("customerSource");

          if (this.$route.path.startsWith("/accounts-receivable")) {
            this.$store.commit("setCurrentStep", 1);
            this.$store.commit("resetAccountsReceivableState");
            router.push({ name: "arDashboard" }).catch(() => {});
          } else {
            router.push("/").catch(() => {});
          }
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    },

    resetTimer() {
      this.$emit("collapse");
      this.$refs.dispositionForm.reset();
      localStorage.removeItem("callEndTime");
      this.$emit("clicked", "reset");
    }
  },

  computed: {
    dispositions() {
      return this.callType ? this.callType.dispositions : [];
    },

    validDisposition() {
      return !!this.disposition && !!this.callType;
    },

    canDispose() {
      if (this.callActive && this.location === "callTracker") {
        return true;
      } else if (this.callActive) {
        return false;
      } else {
        return true;
      }
    }
  },

  created() {
    this.getCallTypes();
  }
};
</script>
